"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
/**
 * Represents User information
 */
var User = /** @class */ (function (_super) {
    __extends(User, _super);
    function User() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "User";
        /**
         * Id of the user
         */
        _this.userId = function () {
            _this.push(function (_) { return "userId"; });
        };
        /**
         * The username of the user
         */
        _this.username = function () {
            _this.push(function (_) { return "username"; });
        };
        /**
         * The email of the user
         */
        _this.email = function () {
            _this.push(function (_) { return "email"; });
        };
        /**
         * The first name of the user
         */
        _this.firstName = function () {
            _this.push(function (_) { return "firstName"; });
        };
        /**
         * The last name of the user
         */
        _this.lastName = function () {
            _this.push(function (_) { return "lastName"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return User;
}(Array));
exports.User = User;
//# sourceMappingURL=User.js.map